import { Subtext } from '@ui-library/typography';
import Tooltip from '@ui-library/tooltip';
import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import classes from '../common.module.scss';

interface AccountFieldProps {
  value: string;
  label: string;
}

interface AccountSummaryProps {
  fields: AccountFieldProps[];
  info: Record<string, string>;
}

const AccountSummary: React.FC<AccountSummaryProps> = ({ fields, info }: AccountSummaryProps) => (
  <div className={classes.auth_account_summary}>
    {fields.map((field: AccountFieldProps) => {
      const fieldValue = get(info, field.value);
      return (
        <Tooltip placement="left" title={fieldValue}>
          <Subtext className={classes.account_info_key}>
            <b>{field.label}</b>
            {' - '}
            {fieldValue}
          </Subtext>
        </Tooltip>
      );
    })}

    <div className={classes.creation_duration_wrapper}>
      <span className={classes.creation_duration}>
        {`Created ${moment(info.createdAt).fromNow()}`}
      </span>
    </div>
  </div>
);
export default AccountSummary;
